export const ACTION_TYPE = 'actionType';
export const OBJECT_TYPE_ID = 'objectTypeId';
export const PROPERTIES = 'properties';
export const PROPERTIES_TARGET_PROPERTY = 'targetProperty';
export const PROPERTIES_VALUE = 'value';
export const ASSOCIATIONS = 'associations';
export const USE_EXPLICIT_ASSOCIATIONS = 'useExplicitAssociations';
export const LINE_ITEMS = 'lineItemFromProductCreateRequests';